/* eslint-disable jira/filename-case */
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { LimitsBanner as LimitsBannerWithoutErrorBoundary } from './LimitsBanner.tsx';
import {
	LimitsBannerV2 as LimitsBannerV2WithoutErrorBoundary,
	type Props,
} from './LimitsBannerV2.tsx';
import {
	LimitsBannerM2M3 as LimitsBannerM2M3WithoutErrorBoundary,
	type Props as LimitsBannerM2M3Props,
} from './LimitsBannerM2M3.tsx';

const LimitsBanner = (): React.JSX.Element => (
	<JSErrorBoundary
		id="limitsBanner"
		packageName="jiraPlatformUiLimitsBanner"
		teamName="jdm-streamlining-tools"
	>
		<LimitsBannerWithoutErrorBoundary />
	</JSErrorBoundary>
);

const LimitsBannerV2 = ({ page }: Props): React.JSX.Element => (
	<JSErrorBoundary
		id="limitsBanner"
		packageName="jiraPlatformUiLimitsBanner"
		teamName="jdm-streamlining-tools"
	>
		<Placeholder name="limits-banner-v2" fallback={null}>
			<LimitsBannerV2WithoutErrorBoundary page={page} />
		</Placeholder>
	</JSErrorBoundary>
);

const LimitsBannerM2M3 = ({ message, limit, link }: LimitsBannerM2M3Props): React.JSX.Element => (
	<JSErrorBoundary
		id="limitsBannerM2M3"
		packageName="jiraPlatformUiLimitsBanner"
		teamName="jdm-streamlining-tools"
	>
		<LimitsBannerM2M3WithoutErrorBoundary message={message} limit={limit} link={link} />
	</JSErrorBoundary>
);

export { LimitsBanner, LimitsBannerV2, LimitsBannerM2M3 };
